import { http } from "@/api/config.js";
import qs from "qs";

export const saveFeedbackApi = (data) => {
  for (let key in data) {
    if (data[key] === "") delete data[key];
  }
  return http({
    url: `/feedbacks/insert?${qs.stringify(data, {
      arrayFormat: "repeat",
    })}`,
    method: "POST",
  });
};
